import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '../../../components/ui/button.tsx';
import Text from '../../../components/ui/text.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';

export type NotReachedBannerProps = {
    active: boolean;
    onChange: (active: boolean) => void;
};

export const NotReachedBanner = ({ active, onChange }: NotReachedBannerProps): ReactNode => {
    const { t } = useLocale();

    if (active) {
        return (
            <div className="flex items-center justify-between rounded-md bg-neutral-50 px-3 py-2">
                <Text weight="semibold">{t('notes__not_reached__active_label', { ns: 'notes' })}</Text>
                <Button
                    variant="link"
                    icon={ArrowLeft}
                    onClick={() => {
                        onChange(false);
                    }}
                >
                    {t('notes__not_reached__back', { ns: 'notes' })}
                </Button>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-between rounded-md bg-neutral-50 px-3 py-2">
            <Text>{t('notes__not_reached__prompt', { ns: 'notes' })}</Text>
            <Button
                variant="link"
                onClick={() => {
                    onChange(true);
                }}
            >
                {t('notes__not_reached__cta', { ns: 'notes' })}
            </Button>
        </div>
    );
};
